import { useEffect } from "react";

/**
 * Reference-counted body scroll lock. While at least one modal holds the
 * lock, `document.body` carries `data-modal-open` and the global stylesheet
 * sets `overflow: hidden`. The width of a body scrollbar, when there is one,
 * becomes `padding-right` for the same span, so hiding it never shifts the
 * page. Nested dialogs release independently.
 */

let holders = 0;
let previousPaddingRight: string | null = null;

function acquire(): () => void {
    holders += 1;
    if (holders === 1) {
        const gutter = window.innerWidth - document.documentElement.clientWidth;
        if (gutter > 0) {
            previousPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = `${String(gutter)}px`;
        }
        document.body.dataset.modalOpen = "";
    }
    let released = false;
    return () => {
        if (released) return;
        released = true;
        holders = Math.max(0, holders - 1);
        if (holders === 0) {
            delete document.body.dataset.modalOpen;
            if (previousPaddingRight !== null) {
                document.body.style.paddingRight = previousPaddingRight;
                previousPaddingRight = null;
            }
        }
    };
}

export function useModalLock(active: boolean): void {
    useEffect(() => {
        if (!active || typeof document === "undefined") return;
        return acquire();
    }, [active]);
}
